import {useTelegram} from './hooks/useTelegram'
import Header from './components/Header/Header'
import {Route, Routes} from 'react-router-dom'
import Client from './components/Client/Client'
import Companies from './components/Companies/Companies'
import AdminCompanies from './components/Admin/Companies'
import Settings from './components/Settings/Settings'
import {observer} from 'mobx-react-lite'
import appStore from './storage/AppStore'
import {useEffect} from 'react'
import Notification from './components/Notification/Notification'
import Loading from './components/Loading/Loading'
import {useSearchParams} from 'react-router'
import NewCompany from './components/Admin/NewCompany'
import "react-phone-input-2/lib/bootstrap.css";
import EditCompany from "./components/Admin/EditCompany";
import NotFound from "./components/NotFound/NotFound";
import Footer from "./components/Footer/Footer";
import AdminHome from "./components/Admin/Home";
import Club from './components/Clubs/Club'
import clubStore from "./storage/ClubStore";
import NewMember from "./components/Clubs/Manager/NewMember";
import './common/style.css'
import './common/choices/style.css'
import Members from "./components/Clubs/Manager/Members";
import EditMember from './components/Clubs/Manager/EditMember'
import NewBranch from "./components/Clubs/Manager/NewBranch";
import Branches from "./components/Clubs/Manager/Branches";
import EditBranch from "./components/Clubs/Manager/EditBranch";
import NewTeam from './components/Clubs/Manager/NewTeam'
import Teams from './components/Clubs/Manager/Teams'
import ShowTeam from './components/Clubs/Manager/ShowTeam'
import EditTeam from "./components/Clubs/Manager/EditTeam";


function App() {
    const {tg, isValid, onToggleTheme} = useTelegram();
    const [searchParams] = useSearchParams();
    
    useEffect(() => {
        const value = searchParams.get("jwt");
        if (value) {
          appStore.setJwt(value)
        }
        }, []
    );
    
    useEffect(() => {
        tg?.ready();
        appStore.init().then(() => {
            if(appStore.user.companies.length === 1) {
                clubStore.getClub(appStore.user.companies[0].company.id)
            }
        });
        if (isValid()){
            tg.BackButton.show();
            tg.BackButton.onClick(() => {
                if (window.history.state.idx === 0) {
                    tg?.close()
                } else {
                    window.history.back()
                }
            })
            tg.onEvent('themeChanged', onToggleTheme);
            tg.onEvent('settingsButtonClicked', () => {
                tg.showAlert('settings opened')
            });
            return () => tg.offEvent('themeChanged', onToggleTheme);
        }
    }, [tg]);
    
    return (
      <>
          <Loading/>
          <Header/>
          <main className="content-wrapper">
              <div className="container pb-5 mb-2 mb-sm-3 mb-lg-4 mb-xl-5">

                <Routes>
                    {appStore.user && appStore.user.id &&
                        <>
                            <Route path={'companies'} element={<Companies/>}/>
                            <Route path={'settings'} element={<Settings/>}/>
                            {appStore.user.is_admin &&
                                <>
                                    <Route path={'/admin'} element={<AdminHome/>}/>
                                    <Route path={'/admin/companies'} element={<AdminCompanies/>}/>
                                    <Route path={'/admin/new_company'} element={<NewCompany/>}/>
                                    <Route path={'/admin/edit_company/:id'} element={<EditCompany/>}/>
                                </>
                            }
                            {clubStore.club.id && clubStore.club.is_manager &&
                                <>
                                    <Route path={'/manager/member/list'} element={<Members/>}/>
                                    <Route path={'/manager/member/new'} element={<NewMember/>}/>
                                    <Route path={'/manager/member/edit/:id'} element={<EditMember/>}/>
                                    <Route path={'/manager/branch/new'} element={<NewBranch/>}/>
                                    <Route path={'/manager/branch/list'} element={<Branches/>}/>
                                    <Route path={'/manager/branch/edit/:id'} element={<EditBranch/>}/>
                                    <Route path={'/manager/team/new'} element={<NewTeam/>}/>
                                    <Route path={'/manager/team/list'} element={<Teams/>}/>
                                    <Route path={'/manager/team/edit/:id'} element={<EditTeam/>}/>
                                    <Route path={'/manager/team/show/:id'} element={<ShowTeam/>}/>
                                </>
                            }
                        </>
                    }
                    <Route index element={<Client/>}/>
                    <Route path={'club/:id'} element={<Club/>}/>
                    <Route path="*" element={<NotFound/>}/>
                </Routes>

              </div>
          </main>
          <Footer/>
          <Notification/>
      </>
    );
}

export default observer(App);
